import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// --- Meta Pixel Code ---
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
// Initialize fbq queue immediately
;
(function (w: any) {
  if (w.fbq) return;
  const n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
})(window);
// Queue pixel events (will replay when fbevents.js loads)
window.fbq('init', '1146490364187509');
window.fbq('track', 'PageView');
// Load fbevents.js script
const pixelScript = document.createElement('script');
pixelScript.async = true;
pixelScript.src = 'https://connect.facebook.net/en_US/fbevents.js';
document.head.appendChild(pixelScript);
// Add noscript fallback when DOM is ready
function addNoscriptFallback() {
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.setAttribute('aria-hidden', 'true');
  img.src = 'https://www.facebook.com/tr?id=1146490364187509&ev=PageView&noscript=1';
  document.body.appendChild(img);
}
if (document.body) {
  addNoscriptFallback();
} else {
  document.addEventListener('DOMContentLoaded', addNoscriptFallback);
}
// --- End Meta Pixel Code ---
render(<App data-id="element-277" />, document.getElementById('root'));